import { Inject, Injectable, Optional } from '@angular/core';
import { LogMessage } from '../models/log-message.model';
import { Transporter, TransporterToken } from '../transporters/transporter.model';
import { LoggerConfiguration, LoggerConfigurationToken } from './logger-config.model';
import LoggerFactory from './logger-factory';

@Injectable()
export class LoggerConfiguratorService<T = LogMessage> {
  constructor(
    @Inject(LoggerConfigurationToken) private options: LoggerConfiguration,
    @Optional() @Inject(TransporterToken) private transporters?: Array<Transporter<T>>
  ) {}

  init() {
    LoggerFactory.configure(this.options, this.transporters);
  }
}
